export class WsClient {
  state: string;
  clientId: string;
  flowName: string;
  userName: string;
  type: string;
}

export class WsServer {
  flowName: string;
  userName: string;
  sessionId: string;
}

export class WsId {
  wsID: string;
}

export interface FlowMessage {
  state: FlowState;
  entityId: string;
  entityType: string;
  flowName: string;
  lockedFlows: {};
  accessToken: string;
}

export enum FlowState {
  PING = 'PING',
  PONG = 'PONG',
  LOCK_FLOW = 'LOCK_FLOW',
  UNLOCK_FLOW = 'UNLOCK_FLOW',
  INIT = 'INIT',
  BROADCAST = 'BROADCAST',
  ERROR = 'ERROR',
  DISCONNECT = 'DISCONNECT',
  LOGOUT = 'LOGOUT',
  RECONNECT = 'RECONNECT',
  ENTITY_ID_CHANGE = 'ENTITY_ID_CHANGE',
}

export const FlowInitMessage: FlowMessage = {
  state: FlowState.INIT,
  lockedFlows: {},
  flowName: '',
  entityId: '',
  entityType: '',
  accessToken: '',
};

export const DISCONNECT_MESSAGE: FlowMessage = {
  state: FlowState.DISCONNECT,
  flowName: '',
  entityId: '',
  entityType: '',
  accessToken: '',
  lockedFlows: {},
};

export const EntityIdChangeMessage: FlowMessage = {
  state: FlowState.ENTITY_ID_CHANGE,
  flowName: '',
  entityId: '',
  entityType: '',
  accessToken: '',
  lockedFlows: {},
};
